<div id="screen"></div>
<div id="dlg">
  <form #userForm="ngForm" name='asdf'>
    <div id="caption">
      <h2><span [innerText]="dialogTitle"></span> &emsp;&emsp;
        <div role="button" (click)="onCancel()"><span class="cvt-icon-closeDelete"></span>
        </div>
      </h2>
    </div>
    <div *ngIf="disableRequests" class="SpinnerContainer" >
      <div class="SpinnerouterCircle Spinnercircle Spinnercircle" ></div>
      <div class="SpinnermiddleCircle Spinnercircle Spinnercircle" ></div>
      <div class="SpinnerinnerCircle Spinnercircle Spinnercircle" ></div>
    </div>

    <div class="report-row">
      <div class="report-title">Standard Detail Report</div>
      <div *ngIf="AuditType === 'rateAudit'" class="report-tile"><a (click)="clickStandardReport()" [class]="getFormClass()"  ><span class="cvt-icon-document grid-cmd-icons" title="Standard Detail Report" ></span>
        <span class="message" *ngIf="longRunningMessage !='' " [innerText]="longRunningMessage" ></span> </a> </div>
      <div *ngIf="AuditType === 'reverseAudit'" class="report-tile"><a (click)="clickStandardReverseAuditReport()" [class]="getFormClass()"  ><span class="cvt-icon-document grid-cmd-icons" title="Standard Detail Report" ></span>
        <span class="message" *ngIf="longRunningMessage !='' " [innerText]="longRunningMessage" ></span> </a> </div>
    </div>
    <div class="report-row">
      <div class="report-title">RAW Export Detail Report</div>
      <div *ngIf="AuditType === 'rateAudit'" class="report-tile"><a (click)="clickRawExportReport()" [class]="getFormClass()"  ><span class="cvt-icon-document grid-cmd-icons" title="Standard Detail Report" ></span>
        <span class="message" *ngIf="longRunningRAWMessage !='' " [innerText]="longRunningRAWMessage" ></span> </a> </div>
      <div *ngIf="AuditType === 'reverseAudit'" class="report-tile"><a (click)="clickRawExportReverseAuditReport()" [class]="getFormClass()"  ><span class="cvt-icon-terms grid-cmd-icons" title="RAW Export Detail Report"></span>
        <span class="message" *ngIf="longRunningRAWMessage !='' " [innerText]="longRunningRAWMessage" ></span> </a> </div>
    </div>
    <div class="report-row" *ngIf="AuditType === 'rateAudit'" >
      <div class="report-title">Summary Analysis Worksheet</div>
      <div class="report-tile"><a (click)="clickSummaryAnalysisWorksheetReport()" [class]="getFormClass()"  ><span class="cvt-icon-travelRequests grid-cmd-icons" title="Summary Analysis Worksheet" ></span>
        <span class="message" *ngIf="longRunningSummaryMessage !='' " [innerText]="longRunningSummaryMessage" ></span> </a> </div>
    </div>
  </form>
</div>
<app-alert></app-alert>
